import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/form/index.js
// module id = 624
// module chunks = 0